import React from 'react';
import { Link, NavLink, Navigate, Outlet, useNavigate } from 'react-router-dom';
import streamApi from '../../services/streamApi';
import { authApi, clearStoredAuth, readStoredToken } from '../../services/authApi';
import { ROUTES } from '../../constants';
import BrandMark from '../common/BrandMark';
import { AdminProvider, useAdmin } from './AdminContext';
import './AdminDashboard.css';

const NAV_ITEMS = [
  { to: ROUTES.ADMIN, label: 'Overview', end: true, icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
    </svg>
  ) },
  { to: ROUTES.ADMIN_REVENUE, label: 'Revenue', icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  ) },
  { to: ROUTES.ADMIN_USERS, label: 'Users', icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ) },
  { to: ROUTES.ADMIN_MODERATION, label: 'Moderation', icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  ) },
  { to: ROUTES.ADMIN_SUPPORT, label: 'Support', icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ) },
  { to: ROUTES.ADMIN_STREAMS, label: 'Streams', comingSoon: true, icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
    </svg>
  ) },
  { to: ROUTES.ADMIN_PAYOUTS, label: 'Payouts', comingSoon: true, icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <line x1="2" y1="10" x2="22" y2="10" />
    </svg>
  ) },
  { to: ROUTES.ADMIN_REPORTS, label: 'Reports', comingSoon: true, icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ) },
  { to: ROUTES.ADMIN_SETTINGS, label: 'Settings', comingSoon: true, icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ) },
];

function AdminShell() {
  const navigate = useNavigate();
  const {
    revenueSummary,
    pendingMedia,
    loading,
    refreshing,
    accessDenied,
    loadDashboard,
  } = useAdmin();

  async function handleLogout() {
    await authApi.logout();
    clearStoredAuth();
    streamApi.clearStreamAuth();
    navigate(ROUTES.WELCOME);
  }

  return (
    <div className="admin-dashboard">
      <nav className="admin-nav">
        <div className="admin-nav__left">
          <Link to={ROUTES.ADMIN} className="admin-nav__logo" aria-label="Open admin dashboard">
            <BrandMark className="admin-nav__brand-mark" compact />
          </Link>
        </div>

        <div className="admin-nav__right">
          <div className="admin-nav__spades" aria-label={`Platform spades ${revenueSummary.total_spades || 0}`}>
            <span className="admin-nav__spades-icon">&#9824;</span>
            <span className="admin-nav__spades-balance">{(revenueSummary.total_spades || 0).toLocaleString()}</span>
          </div>
          <span className="admin-nav__badge">Admin</span>

          <button type="button" className="admin-nav__logout" onClick={handleLogout}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            Log Out
          </button>
        </div>
      </nav>

      <div className="admin-shell">
        <aside className="admin-sidebar">
          <nav className="admin-sidebar__nav" aria-label="Admin sections">
            {NAV_ITEMS.map((item) => {
              const badge = item.to === ROUTES.ADMIN_MODERATION && pendingMedia.length > 0
                ? pendingMedia.length
                : null;

              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => `admin-sidebar__link${isActive ? ' admin-sidebar__link--active' : ''}`}
                >
                  <span className="admin-sidebar__link-icon">{item.icon}</span>
                  <span className="admin-sidebar__link-label">{item.label}</span>
                  {badge !== null && (
                    <span className="admin-sidebar__badge">{badge}</span>
                  )}
                  {item.comingSoon && (
                    <span className="admin-sidebar__soon">Soon</span>
                  )}
                </NavLink>
              );
            })}
          </nav>
        </aside>

        <main className="admin-shell__main">
          <div className="admin-shell__content">
            {loading ? (
              <section className="admin-dashboard__card">
                <div className="admin-dashboard__empty">Loading admin dashboard...</div>
              </section>
            ) : accessDenied ? (
              <section className="admin-dashboard__card admin-dashboard__card--denied">
                <h2 className="admin-dashboard__denied-title">Admin access required</h2>
                <p className="admin-dashboard__denied-copy">
                  This account does not currently have ad-push admin permissions. Add your email or user ID to the
                  admin email or user ID config, then sign in again.
                </p>
              </section>
            ) : (
              <Outlet context={{ refreshing, loadDashboard }} />
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

function AdminLayout() {
  const token = readStoredToken();

  if (!token) {
    return <Navigate to={ROUTES.AUTH} replace />;
  }

  return (
    <AdminProvider>
      <AdminShell />
    </AdminProvider>
  );
}

export default AdminLayout;
